const QUICKPASS_BRAND_COLOUR = '#8054FF'

const QUICKPASS_SUPPORTED_AUTH_PROVIDERS = [
  'email-password',
  'google',
  'magic-link',
] as const

/**
 * The published legal documents, linked from inside the app rather than only
 * from the marketing site.
 *
 * QuickPass collects identity, income and bank data through Didit, Plaid and
 * Certn, and a renter handing over that data has to be able to reach the policy
 * covering it from the screen they are handing it over on. These are absolute
 * because the documents live on the marketing site, not in this app.
 */
const QUICKCASA_PRIVACY_POLICY_URL = 'https://quickcasa.ai/privacy'

const QUICKCASA_TERMS_URL = 'https://quickcasa.ai/terms'

export {
  QUICKPASS_BRAND_COLOUR,
  QUICKPASS_SUPPORTED_AUTH_PROVIDERS,
  QUICKCASA_PRIVACY_POLICY_URL,
  QUICKCASA_TERMS_URL,
}
